import { useContext } from 'react';

import { BuilderCampaignDataContext } from '@features/campaigns/builder/providers/BuilderCampaignDataProvider/providerSetup.ts';

export function useBuilderCampaignData() {
  const context = useContext(BuilderCampaignDataContext);
  if (!context) {
    throw new Error('useBuilderCampaignData must be used within BuilderCampaignDataProvider');
  }
  return context;
}
